<template>
  <div style="height: 100vh; overflow:auto" class="lensListBg">
    <!-- 导航栏 -->
    <Header :title="$t('T_LENSES')" link="projectorInfo" @back="backAction"></Header>
    <div class=" appContent">
      <!-- 列表展示 -->
      <div class="list-box lenslist ">
          <van-radio-group v-model="radioLens" >
            <van-radio v-for='item in tableDataLens' @click="onLensChange(item.id)" :key='item.id' :name="item.id">
              <lensItem :lensData="item"  ></lensItem>
            </van-radio>
          </van-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import lensItem from '@/components/LensItem'
import Header from '@/components/header'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'lensList',
  data () {
    return {
      selectedLensId: '',
      tableDataLens: [],
      fit: 'contain',
      radioLens: '',
      oldLensArr: ['ELPLU02', 'ELPLR04', 'ELPLW04', 'ELPLS04', 'ELPLM06', 'ELPLM07', 'ELPLL07', 'ELPLM09']
    }
  },
  computed: {
    ...mapState([
      'selectedModelData', 'selectedLensData', 'matchingLensID', 'graph'
    ]),
    currentUnit () {
      return this.graph.unit
    }
  },
  watch: {
    matchingLensID (val) {
      this.setTableData()
    }
  },
  created () {
  },
  mounted () {
    this.setTableData()
    if (this.tableDataLens.length > 1) {
      this.tableDataLens.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name)
      })
    }
    this.radioLens = this.selectedLensData.id
  },
  methods: {
    ...mapMutations([
      'MATCHINGLENSID', 'SELECTEDLENSDATA'
    ]),
    onClickLeft () {
      this.$router.push({ path: '/projectorInfo' })
    },

    onLensChange (value) {
      this.selectedLensId = value
      let data = this.$commonJs.findLensDataByIdAndSize(value, this.selectedModelData.lcdSize)
      this.commitSelectedLensData(data)

      this.backAction()
    },

    backAction () {
      this.$emit('close')
    },
    setTableData () {
      if (this.matchingLensID && this.matchingLensID.length) {
        this.tableDataLens = this.matchingLensID.map((item) => {
          const lensId = item.id
          let lensDataAll = this.$commonJs.findLensDataByIdAndSize(lensId, this.selectedModelData.lcdSize)
          let throwRange
          let distanceMin
          let distanceMax
          let isOldLens = false

          if (lensDataAll) {
            let distInfo = lensDataAll.lcd.distInfo.find(item => item.ratio === lensDataAll.lcd.aspectRatio)
            throwRange = { min: distInfo.throwRange.w.min, max: distInfo.throwRange.t.max ? distInfo.throwRange.t.max : distInfo.throwRange.w.max }
          }
          if (this.oldLensArr.indexOf(lensId) !== -1 || lensDataAll.discontinued) {
            isOldLens = true
          }
          let throwRangeToUnit = { min: this.$commonJs.changeUnitDraw(throwRange.min, this.currentUnit, false), max: this.$commonJs.changeUnitDraw(throwRange.max, this.currentUnit, false) }
          let distance = throwRange ? throwRangeToUnit.min + '----' + throwRangeToUnit.max : null
          if (throwRange) {
            distanceMin = throwRangeToUnit.min
            distanceMax = throwRangeToUnit.max
          }
          let vcode = item.name.substring(item.name.indexOf(')') + 1, item.name.length).trim()
          let name = item.name.substring(0, item.name.indexOf(')') + 1)
          return {
            vcode: vcode,
            name: name,
            id: lensId,
            isOldLens: isOldLens,
            distance: distance,
            url: lensDataAll.url,
            distanceMin: distanceMin,
            distanceMax: distanceMax
          }
        })
      } else {
        this.tableDataLens = []
      }
    },
    commitSelectedLensData (data) {
      this.SELECTEDLENSDATA(data)
    }
  },
  components: {
    lensItem,
    Header
  }
}
</script>

<style scoped>
  .list-box{
    padding:10px 0 10px 13px
  }
  .van-radio{
    margin-bottom:10px;
    font-size: 20px
  }
</style>
